export const MAX_VISIBLE_INDIVIDUALS = 4;